<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t('report_customer_loan') }}</li>
        </ol>
        <div class="x_header">
            <div class="pull-left">
                <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)">
                    <i class="fa fa-arrow-circle-o-left"></i>
                    {{ $t('back') }}
                </button>
                <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="print">
                    <i class="fa fa-print"></i>
                    {{$t('print')}}
                </button>
            </div>
            <div class="clearfix"></div>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-3">
                            <div class="form-group">
                                <CustomerDropdown :is-all="true" :place="$t('all')" @select="customerChange"></CustomerDropdown>
                            </div>
                        </div>
                    </div>
                    <table class="table table-bordered table-sm table-striped no-bor">
                        <thead>
                            <tr>
                                <th class="text-center" style="width: 50px;">#</th>
                                <th>{{$t('invoice_no')}}</th>
                                <th>{{$t('date')}}</th>
                                <th>{{$t('customer')}}</th>
                                <th class="text-right">{{$t('amount')}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(ret, index) in list" :key="index">
                                <td class="text-center">{{index+1}}</td>
                                <td>{{ret.Num}}</td>
                                <td>{{$format(ret.Date, 'DD-MM-YYYY')}}</td>
                                <td>{{ret.CustomerName}}</td>
                                <td class="text-right">{{$money(ret.Balance)}}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <th colspan="4" class="text-right">{{$t('total')}}</th>
                                <th class="text-right">{{$money(totalAmount)}}</th>
                            </tr>
                        </tfoot>
                    </table>
                </div>
                <div class="card-footer">
                    <span>{{$t('total_record')}}: {{list.length}}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { CustomerDropdown } from '../Customer';
    export default {
        components: { CustomerDropdown },
        data: function () {
            return {
                query: {
                    CustomerId: '',
                    CompanyId: this.$store.state.company.Id
                },
                list: [],
                totalAmount: 0
            }
        },
        created: function () {
            this.toList();
        },
        methods: {
            toList() {
                var loading = this.$loading.show();
                this.$api().post('report/ar', this.query).then(res => {
                    if (this.$isValid(res)) {
                        this.list = res.data.Json.AR;
                        this.totalAmount = res.data.Json.TotalAmount;
                    }
                }).finally(function () { loading.hide(); });
            },
            customerChange(e) {
                if (e == null) this.query.CustomerId = '';
                else this.query.CustomerId = e.Id;
                this.toList();
            },
            print() {
                let link = '/print/arpreview?';
                if (this.query.CustomerId != '') {
                    link = link + 'cid=' + this.query.CustomerId;
                }
                window.open(link, '_blank');
            }
        }
    }
</script>
